import React, { useCallback, useState } from 'react';
import FilterAndSortPanel from './FiltersAndSortPanel';
import PromotedFilters from './PromotedFilters';
import SelectedFilters from './SelectedFilters';

export default function RegularFilters() {
  const [showPanel, setShowPanel] = useState(false);
  const [panelFocus, setPanelFocus] = useState<string | undefined>();

  const toggleShowPanel = useCallback((section?: string) => {
    setShowPanel((prev) => !prev);
    setPanelFocus(section);
  }, []);

  return (
    <>
      <PromotedFilters toggleShowPanel={toggleShowPanel} />
      <SelectedFilters />

      {showPanel && <FilterAndSortPanel onClose={toggleShowPanel} panelFocus={panelFocus} />}
    </>
  );
}
